import React from 'react'

import AuthenticationOrganism from 'components_new/organisms/Authentication'
import SettingsTemplate from 'components_new/templates/SettingsTemplate'

const Authentication = () => {
  return (
    <>
      <SettingsTemplate>
        <AuthenticationOrganism />
      </SettingsTemplate>
    </>
  )
}

export default Authentication
